import * as React from 'react';
import TextareaInputWrapper from './TextareaInput.style';
import type { TextareaInputProps } from './TextareaInput.types';

const TextareaInput = ({
  disabled,
  inputClassName,
  maxLength,
  name,
  noodleInputClass,
  onChange,
  placeholder,
  rows = 5,
  value,
}: TextareaInputProps) => (
  <TextareaInputWrapper className={noodleInputClass}>
    <textarea
      className={inputClassName}
      disabled={disabled}
      maxLength={maxLength}
      name={name}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      value={value}
    />
  </TextareaInputWrapper>
);

export default TextareaInput;
